import { getMemberVouchers, MemberVouchers } from "@/services/core-api-adapter";
import { useQuery } from "@tanstack/react-query";

export default function useGetMemberVouchers(status?: string) {
  const controller = new AbortController();

  const { data, isPending, isLoading, isError, error } = useQuery({
    queryKey: ["getMemberVouchers", status],
    queryFn: async () => {
      const responseData = await getMemberVouchers({
        signal: controller.signal,
      });
      return responseData as MemberVouchers | null;
    },
  });

  return {
    memberVouchers: data || null,
    memberVouchersFetchError: Boolean(error) || isError,
    isMemberVouchersLoading: isPending || isLoading,
  };
}
